(function () {
  'use strict';

  angular.module('erpRetail')
    .controller('HomeEditController', ['$scope', function () {

    }]);
}());
